import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ScanLine } from "lucide-react";

export const parseScan = (text) => {
  const m = /\/vi\/scan\/(c|t)\/([\w-]+)/.exec(text || "");
  return m ? `/vi/scan/${m[1]}/${m[2]}` : null;
};

function ScanDialog({ open, onOpenChange }) {
  const nav = useNavigate();
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open) return undefined;
    setErr("");
    let qr; let stopped = false;
    const t = setTimeout(() => {
      qr = new Html5Qrcode("qr-reader");
      qr.start({ facingMode: "environment" }, { fps: 10, qrbox: 230 }, (txt) => {
        const path = parseScan(txt);
        if (!path) { setErr("QR code non reconnu par OMNIBAT ONE"); return; }
        stopped = true; qr.stop().catch(() => {}); onOpenChange(false); nav(path);
      }, () => {}).catch(() => setErr("Caméra indisponible : autorisez l'accès à la caméra"));
    }, 150);
    return () => { clearTimeout(t); if (qr && !stopped) qr.stop().catch(() => {}); };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="qr-scan-dialog">
        <DialogHeader><DialogTitle className="font-head">Scanner un QR code</DialogTitle></DialogHeader>
        <div id="qr-reader" className="w-full rounded-lg overflow-hidden bg-slate-900 min-h-[260px]" />
        {err && <p className="text-sm text-rose-600" data-testid="qr-scan-error">{err}</p>}
        <p className="text-xs text-slate-500">Visez le QR code d'une boutique ou d'un tricycle.</p>
      </DialogContent>
    </Dialog>
  );
}

export default function ScanButton({ className = "", big = false }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" className={`${big ? "h-14 text-base font-semibold" : ""} ${className}`} onClick={() => setOpen(true)} data-testid="act-scan">
        <ScanLine className={`${big ? "h-5 w-5 mr-2" : "h-4 w-4 mr-1.5"}`} />{big ? "SCANNER" : "Scanner QR"}
      </Button>
      <ScanDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
